export default __webpack_public_path__ + "static/a9ff2764f1b909822f994e7069baef3b.svg";